import { BlockMilestone } from '@basehub/data/replicache/index'

export const getMilestoneId = ({
  sourceBlockId,
  rootId,
}: {
  sourceBlockId: string
  rootId: string
}) => {
  return `${rootId}__${sourceBlockId}`
}

export const flattenContributors = (
  contributors: BlockMilestone['contributors']
) => {
  return Array.from(new Set(Object.values(contributors).flat().filter(Boolean)))
}
